import React from 'react';
import { InstrumentId } from '../../../../types/common';
import { ActualItem } from './ActualItem';

interface Props {
  currentInstrument: InstrumentId;
  onClick?: () => void;
}

// обертка с рефом и онкликом нужна чтобы мобильный попап работал
export const Select = React.forwardRef<HTMLDivElement, Props>(
  ({ currentInstrument, onClick }, ref) => (
    <div ref={ref} onClick={onClick}>
      <ActualItem id={currentInstrument} />
    </div>
  )
);
